import React from 'react';
import { get,  } from 'lodash';
import { callItemDetailInnerTab as CallItemDetailInnerTabView } from 'ui/views/widgets/callItemDetailInnerTab';
import { CallItemDetailInnerTabService } from 'services/callItemDetailInnerTab';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { withRouter } from 'react-router-dom';
import { DASHBOARD_SUB_ROUTES } from 'constants/route-paths';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { CallItemDetailInnerTab } from 'ui/containers/CallItemDetailInnerTab';
 *
 * // render
 * <CallItemDetailInnerTab propName='propValue'/>
 */
class _CallItemDetailInnerTab extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        // bind methods
        this.handleViewActionClick = this.handleViewActionClick.bind( this );

        this.callItemDetailInnerTabService = new CallItemDetailInnerTabService();

        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
            callId: this.props.callId
        };
        this.fetchComponentData(); // start component data fetch
        
    }

    /**
	 * @desc Fetch component response.
	 */
    async fetchComponentData() {

        log.debug( 'CallItemDetailInnerTab.fetchComponentData()' );

        // cancel ongoing request
        this.callItemDetailInnerTabService.cancel();

        // get status and service data
        const { status, data } = await this.callItemDetailInnerTabService.fetchComponentData( {
            url: this.props.widget.url,
            data: {
                context: { callId: this.state.callId }
            }
        } );

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
            } );
        } else {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                componentData: data,
            } );
        }
    }

    /**
     * @desc On tab action click
     */
    handleViewActionClick( { tab, action } = {} ) {
        log.debug( 'ActionItemDetailInnerTab.handleViewActionClick()' );

        // redirect to member management page
        if( 'view' === action.name ) {
            this.props.history.push( {
                pathname: DASHBOARD_SUB_ROUTES.MEMBER_MANAGEMENT,
                state: { memberId: tab.id, patientId: tab.patientId }
            } );
        }
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <CallItemDetailInnerTabView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                { ...get( this.state, 'componentData', {} ) }
                requestPayload={ this.props.requestPayload }
                callId={ this.state.callId }
                onViewActionClick={ this.handleViewActionClick }
            />
        );
    }
}

// set display name
_CallItemDetailInnerTab.displayName = '_CallItemDetailInnerTab';

// set default props
_CallItemDetailInnerTab.defaultProps = {};

// prop types
_CallItemDetailInnerTab.propTypes = {};

// export with router
export const CallItemDetailInnerTab = withRouter( _CallItemDetailInnerTab );
